namespace $.$$ {
	const unknown = Symbol()
	const total = Symbol()
	export class $exso_table extends $.$exso_table {
		total(): readonly any[] {
			return this.item_columns('')
		}
		@$mol_mem
		item_rows() {
			const items = [...this.items()]
			if (this.reverse()) items.reverse()
			return items.map(i => this.Item(i.id))
		}
		@$mol_mem
		items_map() {
			return new Map(this.items().map(i => [i.id, i]))
		}
		@$mol_mem_key
		item_columns(id: string) {
			return this.columns().map(c => this.Column([id, c]))
		}
		column_title([id, c]: [string, string]) {
			if (Array.isArray(c)) c = c[0]
			return this.columns_meta()[c]?.title || c
		}
		column_contents([id, c]: [string, string[] | string]) {
			if (!Array.isArray(c)) c = [c]
			return c.map(c => this.Column_content([id, c]))
		}
		@$mol_mem_key
		column_content(id: [string, string]) {
			const value = this.column_value(id)
			const unit = this.column_unit(id)
			if (value === unknown) return '-'
			if (value === total) return this.$.$exso_sheets.unique([this.items(), id[1]]).length.toString()
			if (value instanceof $mol_time_moment) return this.$.$exso_format.day(value)
			if (typeof value === 'number') {
				if (unit === 'minutes') return this.$.$exso_format.minutes(value)
				return [this.$.$exso_format.float(value), unit].filter(Boolean).join(' ')
			}
			return `${value}`
		}
		@$mol_mem_key
		column_value([id, c]: [string, string]): number | Symbol {
			const raw_keys = c.split('__')
			if (raw_keys.length === 1) {
				const [key] = raw_keys
				const item = this.items_map().get(id)
				if (item) return item[key] || unknown
				const value = this.items().reduce((acc, i) => acc + i[key], 0)
				if (typeof value === 'number') return value
				return total
			}
			const values = raw_keys.map(c => this.column_value([id, c]))
			return values.reduce((acc, v) => {
				if (typeof acc === 'number' && typeof v === 'number') {
					if (v === 0) return unknown
					return acc / v
				}
				return acc
			})
		}
		@$mol_mem_key
		column_unit([id, c]: [string, string]): string {
			const raw_keys = c.split('__')
			if (raw_keys.length === 1) return this.columns_meta()[raw_keys[0]].unit || ''
			return raw_keys.map(c => this.column_unit([id, c])).join('/')
		}
		Total() {
			if (this.items().length === 1) return null as any
			return super.Total()
		}
		column_content_hint([id, c]: [string, string]) {
			return this.column_title([id, c])
		}
	}
}
